import React, { FC, useEffect, useState } from 'react';
import { ColorModule } from '../../../components/developers/sites/ColorModule';
import { useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { ScriptComponent } from '../../../components/developers/ScriptComponent';
import { getWidgetScript } from '../../../components/developers/sites/UiWidget';
import { getSenseScript } from '../../../components/developers/sites/SenseJS';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { Title } from '../../../components/developers/page-components/Title';
import { fetchMerchantSites } from '../../../store/merchnts/actions/sites';
import { Spinner } from '../../../components/Spinner';
import { IAuthState } from '../../../redux/AuthRedux';
import { checkRoles, CLAIMS } from '../../../utils/roles-helper';

export const MerchantWidgetConfigurationsPage: FC = () => {
	const { id: mid, siteId } = useParams<{ id: string, siteId: string }>();
	const { merchantState: { sitesList, isSitesListLoading }, dispatch } = useMerchants();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const isMerchant = checkRoles(authUser, CLAIMS.MERCHANT_ADMIN);
	const [siteName, setSiteName] = useState<string>('');

	useEffect(() => {
		if (!sitesList?.length) {
			void fetchMerchantSites(dispatch, mid);
			return;
		}
		const site = sitesList?.find(site => site?.id === siteId);
		setSiteName(site?.name);
	}, [sitesList]);

	if (isSitesListLoading) {
		return (
			<div className="card widget-table-min-height">
				<div className="card-body">
					<Spinner pageLoader/>
				</div>
			</div>
		);
	}
	return (
		<>
			<div className="card mb-10">
				<div className="card-header d-flex align-items-center">
					<Title title={siteName} additionalClass="fs-2"/>
				</div>
				<div className="d-md-flex justify-content-between">
					<div className="card-body w-md-50">
						<ScriptComponent
							title="UI Widget script"
							script={getWidgetScript(mid, siteId, siteName)}
						/>
					</div>
					<div className="card-body w-md-50">
						<ScriptComponent
							title="Sense JS script"
							script={getSenseScript(mid, siteId, siteName)}
						/>
					</div>
				</div>
			</div>
			<ColorModule isAdmin={!isMerchant} mid={mid}/>
		</>
	);
};
